import some from "lodash/some";

export const VALID_PLP_PAGE_NAMES = [
  "type",
  "category",
  "subcategory",
  "manufacturerId",
  "brandFamilyId",
  "tagId",
  "distributors",
  "appellation",
  "country",
  "region",
  "rawMaterial",
  "search",
];

export const getProductListingPageNameAndValue = (params: any) => {
  let pageName;
  let pageValue;

  for (const page of VALID_PLP_PAGE_NAMES) {
    const val = params[page];

    // distributors is initialized in the state params as an empty array,
    // so cannot simply check for presence of val here.
    if (val?.length) {
      pageName = page;
      pageValue = val;
      break;
    }
  }

  // if no page name is found, then it's on the all products page
  if (!pageName) {
    pageName = "all_products";
  }

  return { pageName, pageValue };
};

export const reRouteFromOldHomepage = (params: any) => {
  const showProductListing = some(productListingParamKeys, k => {
    const val = params[k];
    if (Array.isArray(val)) {
      return !!val.length;
    } else {
      return !!val;
    }
  });

  if (showProductListing) {
    //@ts-ignore
    window.stateService.go("layout.product_listing", params);
  }
  return;
};

export const productListingParamKeys = [
  "type",
  "category",
  "subcategory",
  "container",
  "distributors",
  "onboarding",
  "manufacturerId",
  "manufacturerName",
  "brandFamilyId",
  "brandFamilyName",
  "tagId",
  "tagName",
  "search",
  "page",
  "appellation",
  "country",
  "region",
  "t",
  "c",
  "s",
  "v",
  "m",
  "b",
  "d",
  "n",
  "r",
  "g",
  "wa",
  "wv",
  "z",
  "dl",
  "fe",
];
